import { useEffect, useRef } from "react";

import { useIntersectionObserver } from "@/hooks";

const useInfiniteScroll = (fetchNextPage: () => void, hasNextPage: boolean) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;

  useEffect(() => {
    if (isVisible && hasNextPage) {
      fetchNextPage();
    }
  }, [isVisible, hasNextPage, fetchNextPage]);

  return ref;
};

export default useInfiniteScroll;
